module.exports = __webpack_public_path__ + "static/media/socourt-mobile-screens.72c801e8.png";